import { Box, Popover } from '@mui/material';

import Help from '@/pages/help/Help';

import { blurOverlaySx, popoverPaperSx } from './HelpPopover.styles';

interface HelpPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const HelpPopover: React.FC<HelpPopoverProps> = ({
  anchorEl,
  onClose,
}) => {
  const open = Boolean(anchorEl);

  return (
    <>
      {open && (
        <Box
          sx={blurOverlaySx}
          aria-hidden="true"
          data-testid="help-blur-overlay"
        />
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableScrollLock
        slotProps={{ paper: { sx: popoverPaperSx } }}
      >
        <Help />
      </Popover>
    </>
  );
};
